import { logAsyncError } from '@Utils/Decorators';
import store from '@Store';
import { showGlobalSpinner, hideGlobalSpinner } from '@Containers/GlobalSpinner/GlobalSpinnerActions';
import { spinnerTypes } from '@Containers/GlobalSpinner/GlobalSpinnerConstants';
import HistoryResource from '@Services/HistoryResource';
import HistoryHelper from '@Services/HistoryHelper';
import { updateDialog, closeDialog } from '@Containers/Dialogs/DialogsActions';
import {
  RECEIVED_RECENT_HISTORY,
  RECEIVED_SAVED_HISTORY,
  HANDLE_VIEW_SAVE_MODAL,
  HANDLE_NAME_CHANGE,
  ON_SUBMIT_SAVE,
  ON_SUBMIT_COMPLETE,
  HANDLE_VIEW_DELETE_MODAL,
  ON_DELETE,
  ON_DELETE_COMPLETE,
  ON_SAVE_UNLOAD,
  typeOfHistorySaveDialog,
  typeOfHistoryConfirmationDialog,
} from './Constants';

export const onSubmitSave = () => ({
  type: ON_SUBMIT_SAVE,
});
export const onSubmitSuccess = (result, isRename) => ({
  type: ON_SUBMIT_COMPLETE,
  payload: result || {},
  responseType: 'success',
  isRename,
});
export const onSubmitFail = (result) => {
  const response = {
    ...result,
    message: 'Error saving this search',
    component: 'History',
  };
  return {
    type: ON_SUBMIT_COMPLETE,
    payload: response || {},
    responseType: 'fail',
  };
};
export const onDeleteClick = () => ({
  type: ON_DELETE,
});
export const onDeleteSuccess = (result) => ({
  type: ON_DELETE_COMPLETE,
  payload: result || {},
  responseType: 'success',
});
export const onDeleteFail = (result) => {
  const response = {
    ...result,
    message: 'Error deleting this search',
    component: 'History',
  };
  return {
    type: ON_DELETE_COMPLETE,
    payload: response || {},
    responseType: 'fail',
  };
};
export const onSaveUnLoad = () => ({
  type: ON_SAVE_UNLOAD,
});
export const receivedRecentHistoryAction = (history, historyTypes) => {
  HistoryHelper.formatHistoryData(history, historyTypes);
  HistoryHelper.updateItemsComments(history);
  return {
    type: RECEIVED_RECENT_HISTORY,
    recentHistory: HistoryHelper.splitHistoryByDBs(history) || [],
    historyTypes,
  };
};
export const fetchRecentHistory = () =>
  logAsyncError(async (dispatch) => {
    const [history, historyTypes] = await Promise.all([HistoryResource.getRecentHistory(), HistoryResource.getHistoryTypes()]);
    dispatch(receivedRecentHistoryAction(history, historyTypes));
  });
export const receivedSavedHistoryAction = (history, historyTypes) => {
  const formattedSavedHistory = HistoryHelper.formatSavedHistoryData([...history]);
  return {
    type: RECEIVED_SAVED_HISTORY,
    savedHistory: formattedSavedHistory || [],
    historyTypes,
  };
};
export const fetchSavedHistory = () =>
  logAsyncError(async (dispatch) => {
    dispatch(showGlobalSpinner(spinnerTypes.progress));
    const [history, historyTypes] = await Promise.all([HistoryResource.getSavedHistory(), HistoryResource.getHistoryTypes()]);
    dispatch(receivedSavedHistoryAction(history, historyTypes));
    dispatch(hideGlobalSpinner(spinnerTypes.progress));
  });

export const handleViewSaveModal = (show, isRecentHistory, groupItemIndex = 0, itemIndex = 0, historyItem = {}) => ({
  type: HANDLE_VIEW_SAVE_MODAL,
  show,
  itemToBeSavedContext: historyItem.context ? historyItem.context : '',
  title: isRecentHistory ? 'Save' : 'Rename',
  historyItem,
  itemIndex,
  groupItemIndex,
});
export const openSaveModal = (props) => (dispatch) => {
  dispatch(
    updateDialog({
      id: typeOfHistorySaveDialog,
      dialogType: typeOfHistorySaveDialog,
    })
  );
  dispatch(handleViewSaveModal(true, true, 0, 0, props.historyItem));
};
export const dispatchOpenViewSaveModal = (...args) => {
  store.dispatch(openSaveModal(...args));
};
export const closeSaveModal = () => (dispatch) => {
  dispatch(
    closeDialog({
      id: typeOfHistorySaveDialog,
    })
  );
  dispatch(handleViewSaveModal(false));
};
export const closeConfirmationModal = () => (dispatch) => {
  dispatch(
    closeDialog({
      id: typeOfHistoryConfirmationDialog,
    })
  );
};
export const openConfirmationModal = (props) => (dispatch) => {
  dispatch(
    updateDialog({
      id: typeOfHistoryConfirmationDialog,
      dialogType: typeOfHistoryConfirmationDialog,
      backdrop: false,
      onClose: () => {
        dispatch(closeConfirmationModal());
      },
      ...props,
    })
  );
};
export const dispatchOpenConfirmationModal = (...args) => {
  store.dispatch(openConfirmationModal(...args));
};
export const handleNameChange = (value) => ({
  type: HANDLE_NAME_CHANGE,
  value,
});
export const onSubmitForm = (historyItem, name, isRename) => {
  const historyItemToSave = { ...historyItem };
  historyItemToSave.searchName = name;
  return logAsyncError(async (dispatch) => {
    try {
      dispatch(onSubmitSave());
      const result = isRename
        ? await HistoryResource.modifyHistory(historyItemToSave)
        : await HistoryResource.saveHistory(historyItemToSave);
      dispatch(onSubmitSuccess(result, isRename));
      dispatch(closeSaveModal());
    } catch (e) {
      Logger.error(e);
      dispatch(onSubmitFail(e));
      if (e && e.statusCode === 401) {
        dispatch(closeSaveModal());
      }
    }
  });
};
export const handleViewDeleteModal = (show, groupItemIndex = 0, itemIndex = 0, historyItem = {}) => ({
  type: HANDLE_VIEW_DELETE_MODAL,
  show,
  historyItem,
  itemIndex,
  groupItemIndex,
});
export const onDelete = (historyItem) => {
  const historyItemToDelete = { ...historyItem };
  return logAsyncError(async (dispatch) => {
    try {
      dispatch(onDeleteClick());
      const result = await HistoryResource.removeHistory(historyItemToDelete);
      dispatch(onDeleteSuccess(result));
      dispatch(handleViewDeleteModal(false));
    } catch (e) {
      Logger.error(e);
      dispatch(onDeleteFail(e));
      if (e && e.statusCode === 401) {
        dispatch(handleViewDeleteModal(false));
      }
    }
  });
};
